// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VnJZL{font-weight:800;margin:30px}.ka9Qm{padding:50px}.ka9Qm button{margin:20px}.ROfyE{width:80%;margin:20px auto}._qxJN{padding-bottom:1px}`, "",{"version":3,"sources":["webpack://./src/pages/instamart/campaign/create/widgets/Stepper/Stepper.module.scss"],"names":[],"mappings":"AAAA,OACI,eAAA,CACA,WAAA,CAGJ,OACI,YAAA,CAGJ,cACI,WAAA,CAGJ,OACI,SAAA,CACA,gBAAA,CAGJ,OACI,kBAAA","sourcesContent":[".title {\n    font-weight: 800;\n    margin: 30px;\n}\n\n.nav {\n    padding: 50px;\n}\n\n.nav button {\n    margin: 20px;\n}\n\n.navigator {\n    width: 80%;\n    margin: 20px auto;\n}\n\n.container {\n    padding-bottom: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `VnJZL`,
	"nav": `ka9Qm`,
	"navigator": `ROfyE`,
	"container": `_qxJN`
};
export default ___CSS_LOADER_EXPORT___;
